import { axios } from '@/utils/request'

const api = {
  Info: '/merchant.php/repair/getInfo'
}

// 预加载
export function getRepInfo (parameter) {
  return axios({
    url: api.Info,
    method: 'get',
    params: parameter
  })
}
